import { useEffect } from 'react';
import { useAppSelector } from '../../redux/hooks';
import { useNavigate, useParams } from 'react-router-dom';

const useInvterviewStatus = (isPortrait = false) => {
  const { token } = useParams();
  const navigate = useNavigate();
  const room = useAppSelector((state) => state.interview);
  const { isAllFinished } = room;

  useEffect(() => {
    if (isAllFinished) {
      navigate(`${isPortrait ? '/h5/process' : '/process'}/${token}`);
    }
  }, [isAllFinished, isPortrait, navigate, token]);
};

export default useInvterviewStatus;
